import React from 'react';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import TabbedPage from '../components/TabbedPage';
import LeaveMasterScreen from '../components/LeaveAttendanceComps/PayrollComps/LeaveMasterScreen';

const TABS = [
    { key: 'setup', label: 'Policy Setup', icon: RuleRoundedIcon, module: 'policy-setup', render: () => <LeaveMasterScreen key="lp-setup" initialTab={0} hideTabBar /> },
    { key: 'types', label: 'Leave Types', icon: CategoryRoundedIcon, module: 'leave-types', render: () => <LeaveMasterScreen key="lp-types" initialTab={1} hideTabBar /> },
    { key: 'calendar', label: 'Working Calendar', icon: CalendarMonthRoundedIcon, module: 'working-calendar', render: () => <LeaveMasterScreen key="lp-calendar" initialTab={2} hideTabBar /> },
    { key: 'shifts', label: 'Assign Shifts', icon: ScheduleRoundedIcon, module: 'assign-shifts', render: () => <LeaveMasterScreen key="lp-shifts" initialTab={3} hideTabBar /> },
];

export default function LeavePolicyPage() {
    return <TabbedPage tabs={TABS} />;
}
